export function filterByClient(row: any, columnId: any, value: any, addMeta: any): boolean {
  const cellValue = row.original.clients;

  return cellValue.some(({ name }: any) => name === value)
}
